/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1Message } from './V1Message'
import {
    V1MessageFromJSON,
    V1MessageFromJSONTyped,
    V1MessageToJSON,
    V1MessageToJSONTyped
} from './V1Message'

/**
 *
 * @export
 * @interface V1MessageList
 */
export interface V1MessageList {
    /**
     *
     */
    items?: Array<V1Message>
}

/**
 * Check if a given object implements the V1MessageList interface.
 */
export function instanceOfV1MessageList(value: object): value is V1MessageList {
    return true
}

export function V1MessageListFromJSON(json: any): V1MessageList {
    return V1MessageListFromJSONTyped(json, false)
}

export function V1MessageListFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1MessageList {
    if (json == null) {
        return json
    }
    return {
        items:
            json['items'] == null
                ? undefined
                : (json['items'] as Array<any>).map(V1MessageFromJSON)
    }
}

export function V1MessageListToJSON(json: any): V1MessageList {
    return V1MessageListToJSONTyped(json, false)
}

export function V1MessageListToJSONTyped(
    value?: V1MessageList | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        items:
            value['items'] == null
                ? undefined
                : (value['items'] as Array<any>).map(V1MessageToJSON)
    }
}
